import {ItemsState} from '../state/payments-items-state';
import {AppState} from '../state/app-state';
import {AddItemsActionTypes, ItemsAction} from '../actions/payments-items.actions';


const initialItemsState : ItemsState = {
    items: []
};


export function itemsActionReducer(state: ItemsState = initialItemsState, action:ItemsAction) : ItemsState {
	switch (action.type) {
		case AddItemsActionTypes.ADD:
			state.items = {...action.payload};
		return {
			items: state.items
		}
	}
}
